// extracted by mini-css-extract-plugin
export default {"SiteFooter":"SiteFooter_SiteFooter__wDz-d"};